// src/config.js

const config = {
  SITE_API_URL: 'https://wapi.jaafaracademy.com/api',
  SITE_API_KEY: 'NWXYkGQNBwWivrWR64rANPtH278@26KM997yc7jg25c3erBkPMsi7b5PSFneDE8dXWN'
  };
  
  export default config;
